import { render, staticRenderFns } from "./VueSelectTempMeal.vue?vue&type=template&id=270c7d89&scoped=true&"
import script from "./VueSelectTempMeal.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempMeal.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempMeal.vue?vue&type=style&index=0&id=270c7d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c7d89",
  null
  
)

component.options.__file = "VueSelectTempMeal.vue"
export default component.exports